import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbNavModule, NgbAccordionModule, NgbDropdownModule, NgbCollapseModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

// Swiper Slider
import { SlickCarouselModule } from "ngx-slick-carousel";

// Counter
import { CountUpModule } from "ngx-countup";

import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { ScrollspyDirective } from "./scrollspy.directive";
import { LandingScrollspyDirective } from "./landingscrollspy.directive";

// Job Landing
import { FlatpickrModule } from "angularx-flatpickr";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RideListComponent } from "./ride-list/ride-list.component";
import { RideDetailsComponent } from "./ride-details/ride-details.component";
import { BookingRideComponent } from "./booking-ride/booking-ride.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgStepperModule } from "angular-ng-stepper";
import { CdkStepperModule } from "@angular/cdk/stepper";
import { ModalComponentsModule } from "./modal-components/modal-components.module";
import { DriverListComponent } from "./driver-list/driver-list.component";
import { DriverDetailsComponent } from "./driver-details/driver-details.component";
import { PipesModule } from "./pipes/pipes.module";

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ScrollspyDirective,
    LandingScrollspyDirective,
    RideListComponent,
    RideDetailsComponent,
    BookingRideComponent,
    DriverListComponent,
    DriverDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    SlickCarouselModule,
    CountUpModule,
    FlatpickrModule.forRoot(),
    TranslateModule,
    NgSelectModule,
    CdkStepperModule,
    NgStepperModule,
    ModalComponentsModule,
    NgbCollapseModule,
    NgbTooltipModule,
    PipesModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    BreadcrumbsComponent,
    ScrollspyDirective,
    LandingScrollspyDirective,
    RideListComponent,
    RideDetailsComponent,
    BookingRideComponent,
    DriverListComponent,
    DriverDetailsComponent
  ]
})
export class SharedModule {}
